import { GlobalCustomerEvents } from '@getgreenline/customer-search'
import { BehaviorSubject } from 'rxjs'

const dataSubject = new BehaviorSubject<{ type: string; payload: unknown } | null>(null)

export const openCustomerMFEModal = ({
  message,
  severity,
}: {
  message: string
  severity: 'success' | 'error'
}) => {
  dataSubject.next({
    type: 'openModal',
    payload: {
      open,
      message,
      severity,
    },
  })
}

export const addToRecipientListInMFE = (customersIds: string[]) => {
  dataSubject.next({
    type: GlobalCustomerEvents.MFE.ADD_TO_RECIPIENT_LIST,
    payload: customersIds,
  })
}

export const clearSelectedGlobalCustomersInMFE = () => {
  dataSubject.next({
    type: GlobalCustomerEvents.MFE.CLEAR_RECIPIENT_LIST_AND_SELECTED_CUSTOMERS,
    payload: null,
  })
}

export const customerMFEObservable = dataSubject.asObservable()
;(window as any).sharedService = {
  openCustomerMFEModal,
  customerMFEObservable,
}
